import script from "./TaxPaidAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxPaidAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./TaxPaidAnalysis.vue?vue&type=style&index=0&id=06183341&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06183341"]])

export default __exports__